import { useState, memo } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import WebhookIcon from "@mui/icons-material/Webhook";
import CreateExternalIntegrationModal from "../modals/ExternalIntegration/CreateExternalIntegrationModal";

const CreateExternalIntegration = ({
  loading,
  error,
  createIntegration,
  sellers,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleCreate = async (data) => {
    try {
      await createIntegration(data);
    } catch (error) {
      console.error(`Error al realizar el request: ${error}`);
    } finally {
      handleCloseModal();
    }
  };

  return (
    <>
      <Grid item md={4} xs={6}>
        <Button
          variant="outlined"
          onClick={handleOpenModal}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={20} />
            ) : (
              <WebhookIcon fontSize="small" />
            )
          }
        >
          {loading ? "Procesando..." : "Nueva Integración"}
        </Button>
      </Grid>

      <CreateExternalIntegrationModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleCreate}
        loading={loading}
        sellers={sellers}
      />
    </>
  );
};

export default memo(CreateExternalIntegration);
